import { serpFeatures } from './serpFeatures'

export const formatSerpHistoryData = data => {
  const dates = []
  const features = {}

  let item = null
  let key = null
  let feature = null

  for (item of data) {
    dates.push(item.attributes.date)
    for ([key, feature] of Object.entries(serpFeatures)) {
      if (!features[key]) {
        features[key] = {
          name: feature,
          data: [item.attributes[key].data]
        }
      } else {
        features[key].data.push(item.attributes[key].data)
      }
    }
  }
  return {
    attributes: {
      dates: dates,
      features: features
    }
  }
}
